import { useEffect } from 'react'
import { useAuthedMe } from '@/features/auth/api'
import { accentVariables } from '../lib'

/** Applies the organisation's accent colour (plan feature `custom_branding`) to the app theme. */
export function BrandingEffect() {
  const me = useAuthedMe()
  const accent = me.current_tenant?.branding?.accent_color ?? null
  useEffect(() => {
    const vars = accentVariables(accent)
    if (!vars) return
    const root = document.documentElement
    for (const [k, v] of Object.entries(vars)) root.style.setProperty(k, v)
    return () => {
      for (const k of Object.keys(vars)) root.style.removeProperty(k)
    }
  }, [accent])
  return null
}

/** The organisation's logo, when branding is enabled and a logo is set. */
export function TenantLogo() {
  const me = useAuthedMe()
  const url = me.current_tenant?.branding?.logo_url
  if (!url) return null
  return <img src={url} alt={`${me.current_tenant?.name ?? 'Organization'} logo`} className="hidden h-7 max-w-28 object-contain sm:block" />
}
